import { orderByDate } from "./utils";
import CanvasJSReact from "@canvasjs/react-charts";

export function getPressureLayout(
  _datapointsPmax,
  _datapointsPmin,
  _datapointsHR,
  showTitle = true,
  small = false,
  includeHR = true,
) {
  const datapointsPmax = orderByDate(_datapointsPmax);
  const datapointsPmin = orderByDate(_datapointsPmin);
  const datapointsHR = orderByDate(_datapointsHR);

  let layout = {
    theme: "light2",
    title: {
      text: showTitle
        ? `Grafico ultime ${datapointsPmax.length} misurazioni`
        : "",
    },
    legend: {
      verticalAlign: "top",
      horizontalAlign: "center",
      dockInsidePlotArea: false,
    },
    toolTip: {
      shared: true,
    },
    axisY: {
      minimum: 20,
      gridThickness: 0.6,
      maximum: 140,
      interval: 20,
    },
    axisX: {
      labelFontSize: small ? 10 : 16,
      labelMaxWidth: small ? 45 : 60,
      stripLines: [],
      gridThickness: 0,
      labelTextAlign: "center",
      labelFormatter: function (e) {
        return CanvasJSReact.CanvasJS.formatDate(e.label, "DD/MM YYYY HH:mm");
      },
    },
    data: [
      {
        name: "Press. Massima",
        type: "area",
        showInLegend: true,
        legendMarkerType: "square",
        color: "#b7e1b7",
        markerColor: "#139d13",
        dataPoints: datapointsPmax.map((el) => {
          return {
            label: el.x,
            y: el.y,
          };
        }),
      },
      {
        name: "Press. Minima",
        type: "area",
        showInLegend: true,
        legendMarkerType: "square",
        color: "#4a79a0",
        markerColor: "#43739f",
        dataPoints: datapointsPmin.map((el) => {
          return {
            label: el.x,
            y: el.y,
          };
        }),
      },
    ],
  };
  if (includeHR) {
    layout.data.push({
      name: "Freq. Cardiaca",
      type: "spline",
      showInLegend: true,
      legendMarkerType: "square",
      color: "#8e5948",
      lineColor: "#8e5948",
      dataPoints: datapointsHR.map((el) => {
        return {
          label: el.x,
          y: el.y,
        };
      }),
    });
  }

  return layout;
}

export function parsePressureReports(measures) {
  let datapointsPmax = [];
  let datapointsPmin = [];
  let datapointsHR = [];

  // prendo le misurazioni di pressioni/hr + data
  measures.forEach((report, index) => {
    if (report.data.Pmax !== null && report.data.Pmax !== undefined) {
      datapointsPmax.push({
        x: report.data.Date,
        y: eval(report.data.Pmax),
      });

      datapointsPmin.push({
        x: report.data.Date,
        y: eval(report.data.Pmin),
      });

      datapointsHR.push({
        x: report.data.Date,
        y: eval(report.data.HR),
      });
    }
  });

  return {
    datapointsPmax: datapointsPmax,
    datapointsPmin: datapointsPmin,
    datapointsHR: datapointsHR,
  };
}

export function generatePressureChart(
  reports,
  small = false,
  includeHR = true,
) {
  const { datapointsPmax, datapointsPmin, datapointsHR } =
    parsePressureReports(reports);

  // genero il report
  const layout = getPressureLayout(
    datapointsPmax,
    datapointsPmin,
    datapointsHR,
    false,
    small,
    includeHR,
  );

  return layout;
}
